import SelectInventory from './SelectInventory'
export default SelectInventory
